export default __webpack_public_path__ + "static/media/ic_history.58f94cf2.webp";